import React from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { usePanelContext } from 'hb-builder/hooks';

const PanelTab = ({ tab }) => {
  const { selectedPanelTab, setSelectedPanelTab } = usePanelContext();

  return (
    <StyledPanelTab
      data-testid={`builder-tab-${tab.id}`}
      isSelected={selectedPanelTab === tab.id}
      onClick={() => setSelectedPanelTab(tab.id)}
    >
      {tab.label}
    </StyledPanelTab>
  );
};

export default PanelTab;

const StyledPanelTab = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) => !['isSelected'].includes(prop),
  })
  .attrs(() => ({
    alignItems: 'center',
    flex: 1,
    fontWeight: 1,
    height: 54,
    justifyContent: 'center',
    p: 4,
  }))`
  cursor: ${(props) => (props.isSelected ? 'default' : 'pointer')};
  font-size: 18px;
  pointer-events: ${(props) => props.isSelected && 'none'};
  user-select: none;
  white-space: nowrap;
`;
